import React, { useEffect, useState } from "react";
import "../../assets/css/SalesTrend/SalesTrend.css";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useSalesContext } from '../../Pages/SalesContext';
import { API_BASE_URL } from "../../config/config";
import SalesTrendHeader from "../../Pages/SalesTrendHeader";
import BreakageFilter from "./component/BreakageFilter";
import BreakwiseDataComponent from "./component/BreakwiseDataComp";
import BreakwiseTable from "./component/BreakwiseTable";
import { useTokenFromQuery, useFetchUserDetails, getUserIdFromToken ,useResetRefreshTime } from "../../utils/dashboardUtils.js";
interface DecodedToken {
  name: string;
  preferred_username: string;
}


const Breakage_Dashboard: React.FC = () => {
  const [refreshTime, setRefreshTime] = useState<string | null>(null);
  const [userLocation, setUserLocation] = useState<string | null>(null);
  const [headerUsername, setHeaderUsername] = useState<string | null>(null);
  useTokenFromQuery("/app/breakage_dashboard");
  useFetchUserDetails(setUserLocation, setHeaderUsername, setRefreshTime, API_BASE_URL,"breakage_dashboard");
  useResetRefreshTime(setRefreshTime);
  const user_id = getUserIdFromToken();

  return (
    <div className="sales-trend-dashboard">
      <div className="dashboard-container">
        <SalesTrendHeader
          title="Breakage Expiry & Return"
             userName={headerUsername}
          location={userLocation}
          refreshTime={refreshTime}
        />
        <BreakageFilter user_id={user_id} />
        <BreakwiseDataComponent />
        <BreakwiseTable />
      </div>
    </div>
  );
};

export default Breakage_Dashboard;
